import classNames from "classnames";

import styles from "./StateMessage.module.css";

type PropTypes = {
  state: "success" | "loading";
  message: string;
};

const StateMessage: React.FC<PropTypes> = ({ state = "success", message }) => {
  return (
    <div className={classNames(styles.messageWrapper, { [styles.loading]: state === "loading" })}>
      <span className={classNames(styles.message, { [styles.messageLoading]: state === "loading" })}>{message}</span>
    </div>
  );
};

export default StateMessage;
